import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import _ from 'lodash';

import EntityStateUpdater from 'component/EntityStateUpdater';

import { changeUploadContext, resetUploadContext } from 'actions/UploadActions';
import { updateFormContext, resetFormContext, formStatusDispatchHelper, formReset } from 'actions/FormStatusActions';
import { addNotification } from 'actions/NotificationsActions';

import Breadcrumb from 'components/layout/Breadcrumb';
import Tabs from 'components/layout/Tabs';
import FabActions from 'components/layout/FabActions';
import FabActionElement from 'components/layout/FabActionElement';

import OrderHeader from 'components/layout/order/OrderHeader';
import OrderInfo from 'components/layout/order/OrderInfo';
import OrderTimeline from 'components/layout/order/OrderTimeline';
import OrderDocs from 'components/layout/order/OrderDocs';
import OrderInvoices from 'components/layout/order/OrderInvoices';
import OrderActions from 'components/layout/order/OrderActions';

import Entity from 'components/Entity';
import Data from 'components/Data';

import { entityMetaMapping } from 'js/constants';

import FormErrors from 'components/forms/FormErrors';

class OrderViewEmployee extends EntityStateUpdater {
  constructor(props) {
    super(props);

    this.state = {
      entity: null,
      entityLoaded: false,
      entityChanged: false,
      key: 1,
    };

    this.entity = new Entity();

    // if we get user data from the outside, we can pass it on to our data entity
    if (props.orderData) {
      this.entity.setData(props.orderData);
    }

    if (props.meta[entityMetaMapping.order] !== undefined && !props.meta[entityMetaMapping.order].pending) {
      this.entity.setMeta(props.meta, entityMetaMapping.order);
    }

    if (this.entity.getDataLoaded() && this.entity.getMetaLoaded()) {
      this.state = {
        ...this.state,
        entityLoaded: true,
        entity: this.entity,
      };
    }
  }

  componentWillMount = () => {
    if (false) {
    } else {
      this.props.updateUploadContext({
        type: 'order_img',
        orderId: this.props.orderId,
        uploadLink: '/api/orders/' + this.props.orderId + '/files.json',
      });

      this.props.updateFormContext(this.props.orderId);
    }
  };

  componentWillUnmount = () => {
    this.props.doResetUploadContext();
    this.props.doResetFormContext();
  };

  componentWillUpdate = nextProps => {
    // order data was saved and there was no error
    if (this.props.formStatus.pending && !nextProps.formStatus.pending && !nextProps.formStatus.hasError) {
      this.setState({ entityChanged: false, key: this.state.key + 1 });
      this.props.doNotify(1, this.props.intl.messages.order_saved);
    }

    // check if the car order was just approved
    if (
      this.props.orderActionApproveCarSaleFormStatus.pending &&
      !nextProps.orderActionApproveCarSaleFormStatus.pending &&
      !nextProps.orderActionApproveCarSaleFormStatus.hasError
    ) {
      // lead was just moved to the next stage and updated in redux
      // new timeline entry got created, so add the newest timeline entry to the entity
      this.addTimelineEntry([nextProps.data.data.timeline[0]]);
    }

    // check if VIN number was just updated
    if (
      this.props.orderActionEnterVinNumberFormStatus.pending &&
      !nextProps.orderActionEnterVinNumberFormStatus.pending &&
      !nextProps.orderActionEnterVinNumberFormStatus.hasError
    ) {
      // the VIN number was just updated in redux; update the vin number in the entity (by updating the order items)
      const items = nextProps.data.data.items.map(item => {
        return this.state.entity.createValue('items', [], item);
      });

      this.updateEntityMultiple(
        ['items'],
        [items],
        [],
        () => {
          this.addTimelineEntry([nextProps.data.data.timeline[0]]);
        },
        false
      );
    }

    if (
      this.props.orderActionEnterEinNumberFormStatus.pending &&
      !nextProps.orderActionEnterEinNumberFormStatus.pending &&
      !nextProps.orderActionEnterEinNumberFormStatus.hasError
    ) {
      this.updateEntityMultiple(
        ['ein'],
        [nextProps.data.data.ein],
        [],
        () => {
          this.addTimelineEntry([nextProps.data.data.timeline[0]]);
        },
        false
      );
    }

    if (
      this.props.orderActionMarkCarAsPaidFormStatus.pending &&
      !nextProps.orderActionMarkCarAsPaidFormStatus.pending &&
      !nextProps.orderActionMarkCarAsPaidFormStatus.hasError
    ) {
      // lead was just moved to the next stage and updated in redux
      // car wire transfer payment status was updated
      // new timeline entry got created, so add the newest timeline entry to the entity
      this.updateEntityMultiple(
        ['carWireTransferPayment'],
        [nextProps.data.data.car_wire_transfer_payment],
        [],
        () => {
          this.addTimelineEntry([nextProps.data.data.timeline[0]]);
        },
        false
      );
    }

    if (
      this.props.orderActionSendPaymentInstructionsFormStatus.pending &&
      !nextProps.orderActionSendPaymentInstructionsFormStatus.pending &&
      !nextProps.orderActionSendPaymentInstructionsFormStatus.hasError
    ) {
      // the payment instructions were just sent to the client (when paying for car with wire transfer)
      // update the entity and the timeline
      this.updateEntityMultiple(
        ['carWireTransferPayment'],
        [nextProps.data.data.car_wire_transfer_payment],
        [],
        () => {
          this.addTimelineEntry([nextProps.data.data.timeline[0]]);
        },
        false
      );
    }

    if (
      this.props.orderActionCancelOrderFormStatus.pending &&
      !nextProps.orderActionCancelOrderFormStatus.pending &&
      !nextProps.orderActionCancelOrderFormStatus.hasError
    ) {
      this.updateEntityMultiple(
        ['isCancelled', 'cancellationReason', 'cancellationText', 'stripePayment'],
        [
          nextProps.data.data.is_cancelled,
          nextProps.data.data.cancellation_reason,
          nextProps.data.data.cancellation_text,
          nextProps.data.data.stripe_payment,
        ],
        [],
        () => {
          this.addTimelineEntry([nextProps.data.data.timeline[0]]);
        },
        false
      );
    }

    if (
      this.props.orderActionPickupInviteFormStatus.pending &&
      !nextProps.orderActionPickupInviteFormStatus.pending &&
      !nextProps.orderActionPickupInviteFormStatus.hasError
    ) {
      // the invitation to pick the order up was just sent to the client
      // update the entity and the timeline
      this.updateEntityMultiple(
        ['pickupData'],
        [nextProps.data.data.pickup_data],
        [],
        () => {
          this.addTimelineEntry([nextProps.data.data.timeline[0]]);
        },
        false
      );
    }

    if (
      this.props.orderActionPickedUpFormStatus.pending &&
      !nextProps.orderActionPickedUpFormStatus.pending &&
      !nextProps.orderActionPickedUpFormStatus.hasError
    ) {
      // the order was just marked as picked up
      // update the entity and the timeline
      this.updateEntityMultiple(
        ['pickupData'],
        [nextProps.data.data.pickup_data],
        [],
        () => {
          this.addTimelineEntry([nextProps.data.data.timeline[0]]);
        },
        false
      );
    }

    if (
      (this.props.orderActionMarkAssigneeKroschkeDocumentsSent.pending &&
        !nextProps.orderActionMarkAssigneeKroschkeDocumentsSent.pending &&
        !nextProps.orderActionMarkAssigneeKroschkeDocumentsSent.hasError) ||
      (this.props.orderActionDefineCustomLicensePlateNumber.pending &&
        !nextProps.orderActionDefineCustomLicensePlateNumber.pending &&
        !nextProps.orderActionDefineCustomLicensePlateNumber.hasError)
    ) {
      // employee marked that the documents needed for kroschke car registration were sent
      // -or- employee updated the license plate registration data
      // update the entity and the timeline
      this.updateEntityMultiple(
        ['carRegistrationData'],
        [nextProps.data.data.car_registration_data],
        [],
        () => {
          this.addTimelineEntry([nextProps.data.data.timeline[0]]);
        },
        false
      );
    }

    // entity actions:
    if (this.props.data.pending && !nextProps.data.pending) {
      this.entity.setData(nextProps.data.data);
      if (this.entity.getMetaLoaded()) {
        this.setState({ entityLoaded: true, entity: this.entity, key: this.state.key + 1 });
      }
    }

    if (
      this.props.meta[entityMetaMapping.order] !== undefined &&
      !nextProps.meta[entityMetaMapping.order].pending &&
      !this.entity.getMetaLoaded()
    ) {
      this.entity.setMeta(nextProps.meta, entityMetaMapping.order);
      if (this.entity.getDataLoaded()) {
        this.setState({ entityLoaded: true, entity: this.entity, key: this.state.key + 1 });
      }
    }
  };

  isServiceBooked = serviceName => {
    const { entity, entityLoaded } = this.props;

    if (entityLoaded) {
      return _.findIndex(entity.getServices(), ['name', serviceName]) > -1;
    }

    return false;
  };

  formSubmit = e => {
    e.preventDefault();

    this.setState({ entity: this.state.entity.validate() }, () => {
      if (this.state.entity.isValid) {
        // ommit embedded data like
        const data = _.omit(this.state.entity.processedData, ['']);
        this.props.onSubmit(this.props.orderId, data);
      }
    });
  };

  getTabHeaderList = () => {
    const { intl, layout } = this.props;
    const messages = intl.messages;

    let result = [];

    result.push(messages.infos);
    if (layout.breakpointIndex <= 1) {
      result.push(messages.timeline);
    }
    result.push(messages.documents);
    result.push(messages.salesDoc.invoices);

    return result;
  };

  getTabContentList = () => {
    const { formStatus, layout } = this.props;
    const { entity, entityLoaded } = this.state;

    const result = [];

    result.push(
      <OrderInfo
        entityLoaded={entityLoaded}
        entity={entity}
        changeEntity={this.changeEntity}
        disabled={formStatus.pending}
        viewKey={this.state.key}
      />
    );
    if (layout.breakpointIndex <= 1) {
      result.push(
        <OrderTimeline
          entityLoaded={entityLoaded}
          entity={entity}
          changeEntity={this.changeEntity}
          disabled={formStatus.pending}
          viewKey={this.state.key}
        />
      );
    }
    result.push(
      <OrderDocs
        orderEntityLoaded={entityLoaded}
        orderEntity={entity}
        changeEntity={this.changeEntity}
        disabled={formStatus.pending}
        viewKey={this.state.key}
      />
    );
    result.push(
      <OrderInvoices
        entityLoaded={entityLoaded}
        entity={entity}
        changeEntity={this.changeEntity}
        disabled={formStatus.pending}
        viewKey={this.state.key}
      />
    );

    return result;
  };

  getTabKeepMounted = () => {
    let keepMounted = [];
    return keepMounted;
  };

  addTimelineEntry = timelineEntries => {
    let timeline = this.state.entity.getTimeline().slice();

    for (let i = 0; i < timelineEntries.length; i++) {
      timeline.splice(0, 0, this.state.entity.createValue('timeline', [], { ...timelineEntries[i] }));
    }

    this.updateEntity('timeline', timeline, [], null, false);
  };

  render() {
    const { intl, appIntl, formStatus, data, leadData } = this.props;
    const messages = intl.messages;

    const { entityLoaded, entity } = this.state;

    const order = this.props.orderData ? this.props.orderData : data.data;

    let addActions = [];
    if (entityLoaded) {
      addActions.push(
        <FabActionElement
          size="60"
          icon="fa fa-gem"
          caption={messages.lead}
          action={() => this.props.history.push(appIntl.urlPrefix + 'account/leads/' + entity.getLeadId())}
        />
      );
    }

    return (
      <div class="padding-25 sm-padding-10">
        <FormErrors formStatus={formStatus} />

        <form method="put" onSubmit={this.formSubmit}>
          {/* data should not be fetched if we got the data as props */}
          {/* we do need the meta data though */}
          {this.props.orderData !== undefined ? (
            <Data dataName="order" />
          ) : (
            <Data dataName="order" url={'/api/orders/' + this.props.orderId + '.json'} data={data} />
          )}

          {entityLoaded ? (
            <Data
              dataName="lead"
              url={'/api/leads/' + entity.getLeadId() + '.json'}
              data={leadData}
              key="order-lead-data"
            />
          ) : null}

          <Breadcrumb
            crumbs={[
              { link: appIntl.urlPrefix + 'account', name: 'Dashboard' },
              { link: appIntl.urlPrefix + 'account/orders', name: messages.orders },
              { link: null, name: order.id },
            ]}
          />

          <section class="panel no-padding">
            <div class="lead-details-header">
              <Row>
                <Col xs={12}>
                  <OrderHeader entity={entity} entityLoaded={entityLoaded} orderKey={this.state.key} />
                </Col>
              </Row>
            </div>
          </section>

          {entityLoaded && !leadData.pending ? (
            <Row>
              <Col xs={12}>
                <div class="text-right m-b-10">
                  <FabActions>
                    <OrderActions
                      order={data.data}
                      wrapperComponent={null}
                      listItemComponent={<FabActionElement size="60" />}
                      addActions={addActions}
                    />
                  </FabActions>
                </div>
              </Col>
            </Row>
          ) : null}

          <Row>
            <Col xs={12}>
              <Tabs
                tabs={this.getTabHeaderList()}
                tabContent={this.getTabContentList()}
                keepMounted={this.getTabKeepMounted()}
              />
            </Col>
          </Row>
        </form>
      </div>
    );
  }
}
OrderViewEmployee.defaultProps = {};

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    data: state.data.order,
    leadData: state.data.lead,
    meta: state.entityMeta,
    user: state.login.user,
    formStatus: state.formStatus.orderEdit,
    layout: state.layout,
    orderActionApproveCarSaleFormStatus: state.formStatus.orderActionApproveCarSale,
    orderActionEnterVinNumberFormStatus: state.formStatus.orderActionEnterVinNumber,
    orderActionEnterEinNumberFormStatus: state.formStatus.orderActionEnterEinNumber,
    orderActionMarkCarAsPaidFormStatus: state.formStatus.orderActionMarkCarAsPaid,
    orderActionSendPaymentInstructionsFormStatus: state.formStatus.orderActionSendPaymentInstructions,
    orderActionCancelOrderFormStatus: state.formStatus.orderActionCancelOrder,
    orderActionPickupInviteFormStatus: state.formStatus.orderActionPickupInvite,
    orderActionPickedUpFormStatus: state.formStatus.orderActionPickedUp,
    orderActionCancelBookingFormStatus: state.formStatus.orderActionCancelBooking,
    orderActionMarkAssigneeKroschkeDocumentsSent: state.formStatus.orderActionMarkAssigneeKroschkeDocumentsSent,
    orderActionDefineCustomLicensePlateNumber: state.formStatus.orderActionDefineCustomLicensePlateNumber,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    updateFormContext: id => {
      dispatch(updateFormContext('order', id));
    },
    doResetFormContext: () => {
      dispatch(resetFormContext());
    },
    updateUploadContext: newContext => {
      dispatch(changeUploadContext(newContext));
    },
    doResetUploadContext: () => {
      dispatch(resetUploadContext());
    },
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
    onSubmit: (orderId, args) => {
      formStatusDispatchHelper('orderEdit', '/api/orders/' + orderId + '.json', args, 'put', dispatch);
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(OrderViewEmployee)
  )
);
